export default "__VITE_ASSET__Bo0AsZ6z__"